import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgb(0 0 0 / 50%);
  backdrop-filter: blur(12px);
  z-index: 10000;
  display: flex;
  justify-content: center;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-bottom: 80px;
  height: 100%;
  width: 100%;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 40px;
    background: linear-gradient(to top, transparent, black);
    pointer-events: none;
    z-index: 1;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 150px;
    background: linear-gradient(to bottom, transparent 0%, black 90%);
    pointer-events: none;
  }
`;

export const OptionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 120px 20px 170px 20px;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  align-items: center;

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }
  
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
`;

export const Option = styled.button<{ $isSelected: boolean; $isDisabled?: boolean }>`
  padding: 16px;
  border: none;
  background: ${props => props.$isSelected ? 'white' : 'transparent'};
  color: ${props => {
    if (props.$isDisabled) return 'rgba(255, 255, 255, 0.3)';
    return props.$isSelected ? '#191540' : 'white';
  }};
  text-align: center;
  cursor: ${props => props.$isDisabled ? 'not-allowed' : 'pointer'};
  border-radius: 50px;
  font-size: 1.5rem;
  width: 100%;
  max-width: 400px;
  font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen';
  opacity: ${props => props.$isDisabled ? 0.5 : 1};
  
  &:hover {
    background: ${props => {
      if (props.$isDisabled) return 'transparent';
      return props.$isSelected ? 'white' : 'rgba(255, 255, 255, 0.1)';
    }};
  }
`;

export const CloseButton = styled.button`
  background: white;
  border: none;
  color: #191540;
  cursor: pointer;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s ease;
  z-index: 1000;

  &:hover {
    transform: translateX(-50%) scale(1.1);
  }

  &:active {
    transform: translateX(-50%) scale(0.95);
  }
`; 